import { animate, style, transition, trigger } from '@angular/animations';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { LinkCard } from '~app/modules/storyblok/models';
import { GridHeightUtil } from '~app/modules/storyblok/utils/grid-height.util';
import { environment } from '~env/environment';
import { GaTrackingEventAction, GaTrackingEventName, GATrackingEventType } from '~shared/modules/ga-tracking/constants';
import { GtmDatalayerService } from '~shared/services/gtm-datalayer.service';

@Component({
  selector: 'app-popular-links-mobile',
  templateUrl: './popular-links-mobile.component.html',
  styleUrls: ['./popular-links-mobile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('fadeIn', [
      transition(':enter', [style({ opacity: '0' }), animate('.3s ease-in', style({ opacity: '1' }))]),
      transition(':leave', [style({ opacity: '1' }), animate('.3s ease-out', style({ opacity: '0' }))]),
    ]),
  ],
})
export class PopularLinksMobileComponent {
  @Input() cardList: Array<LinkCard>;

  readonly marketplaceLink = environment.appBaseUrl();

  readonly MIN_MOBILE_CARDS = 4;
  readonly MAX_MOBILE_CARDS = 20;
  readonly MOBILE_CARD_HEIGHT = 180;
  readonly MOBILE_CARD_GAP = 16;
  readonly MOBILE_CARDS_PER_ROW = 2;

  constructor(private gtmDatalayerService: GtmDatalayerService) {}

  showAllLinks = false;
  sbFormatParam = '/m/';

  get limit(): number {
    return this.showAllLinks ? this.cardList.length : this.MIN_MOBILE_CARDS;
  }

  get showAllLinksButton(): boolean {
    return this.cardList.length > this.MIN_MOBILE_CARDS;
  }

  get maxHeightMobile(): number {
    return GridHeightUtil.getGridMaxHeight(
      this.cardList.length,
      this.MOBILE_CARDS_PER_ROW,
      this.MOBILE_CARD_GAP,
      this.MOBILE_CARD_HEIGHT
    );
  }

  get minHeightMobile(): number {
    return GridHeightUtil.getGridMinHeight(this.MOBILE_CARD_HEIGHT, this.MOBILE_CARD_GAP);
  }

  onShowAllClick(): void {
    if (this.showAllLinks) {
      this.showLessCardsEvent();
    } else {
      this.showAllCardsEvent();
    }
    this.showAllLinks = !this.showAllLinks;
  }

  private showAllCardsEvent(): void {
    this.gtmDatalayerService.gtagEvent({
      event: GATrackingEventType.SE_POPULAR_LINKS_SHOW_MORE,
      GA_eventname: GaTrackingEventName.Interaction,
      action: GaTrackingEventAction.POPULAR_LINKS_SHOW_MORE,
    });
  }

  private showLessCardsEvent(): void {
    this.gtmDatalayerService.gtagEvent({
      event: GATrackingEventType.SE_POPULAR_LINKS_SHOW_LESS,
      GA_eventname: GaTrackingEventName.Interaction,
      action: GaTrackingEventAction.POPULAR_LINKS_SHOW_LESS,
    });
  }
}
